import { render, staticRenderFns } from "./eventGroupTournaments.vue?vue&type=template&id=26433726&scoped=true&"
import script from "./eventGroupTournaments.vue?vue&type=script&lang=js&"
export * from "./eventGroupTournaments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26433726",
  null
  
)

export default component.exports